import { CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * Confirmation state shown after a successful inquiry submission.
 */
const InquirySuccessState = ({ onClose }) => (
  <div className="flex flex-col items-center text-center gap-3 py-8" data-testid="inquiry-success-state">
    <CheckCircle2 className="h-12 w-12 text-[color:var(--brand-gold-2)]" />
    <h3 className="font-[var(--font-serif)] text-xl text-[color:var(--brand-charcoal)]">Talebiniz Alındı</h3>
    <p className="text-sm text-[color:hsl(var(--muted-foreground))] max-w-sm">
      İlginiz için teşekkür ederiz. Abdullah Karslı Gayrimenkul danışmanlarımız en kısa sürede sizinle iletişime geçecektir.
    </p>
    <Button
      data-testid="inquiry-close-success-button"
      onClick={onClose}
      className="mt-2 bg-[linear-gradient(135deg,#D4AF37_0%,#C5A059_55%,#E7D7A6_100%)] text-[color:var(--brand-charcoal)]"
    >
      Kapat
    </Button>
  </div>
);

export default InquirySuccessState;
